import { useTranslation } from "react-i18next";
import { PurchaseButton } from "@/components/common/PurchaseButton";
import YouTubePlayer from "@/components/common/YouTubePlayer";

interface UserVideosProps {
  onPurchase?: () => void;
}

interface VideoItem {
  url: string;
  youtubeUrl: string;
  cover: string;
}

const UserVideos = ({ onPurchase }: UserVideosProps) => {
  const { t } = useTranslation();
  const videoUrls = t('userVideos.videoUrls', { returnObjects: true }) as VideoItem[];

  return (
    <section className="py-8 w-screen lg:w-full mx-auto">
      <div className="px-0 md:px-8 lg:px-0">
        <div className="max-w-7xl mx-auto text-center mb-8 px-2">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-4 md:mb-6">
            {t("userVideos.title")}
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto px-8 md:px-0">
            {t("userVideos.description")}
          </p>
        </div>

        <div className="mt-4 md:mt-8 md:mb-4 relative">
          <div
            className="absolute left-0 top-0 bottom-0 w-8 md:w-12 z-10 pointer-events-none hidden md:block"
            style={{
              background: 'linear-gradient(to right, rgb(248 250 252) 0%, rgba(248, 250, 252, 0) 100%)'
            }}
          />
          <div className="flex overflow-x-auto gap-4 pb-4 px-4 md:px-12 no-scrollbar">
            {videoUrls.map((video, index) => (
              <div
                key={`${video.url}-${index}`}
                className="flex-shrink-0 w-[280px] md:w-[280px] aspect-[9/16]"
              >
                <YouTubePlayer
                  youtubeUrl={video.youtubeUrl}
                  poster={video.cover}
                  objectFit="cover"
                />
              </div>
            ))}
          </div>
          <div
            className="absolute right-0 top-0 bottom-0 w-8 md:w-12 z-10 pointer-events-none hidden md:block"
            style={{
              background: 'linear-gradient(to left, rgb(248 250 252) 0%, rgba(248, 250, 252, 0) 100%)'
            }}
          />
        </div>
      </div>

      {onPurchase && <PurchaseButton onPurchase={onPurchase} />}

    </section>
  )
}

export default UserVideos


// {/* Instagram */}

// {(isMobile || layout === 'carousel') ? (
//   // Carousel Layout
//   <div className="relative">
//     {/* Left gradient shadow */}
//     <div className="absolute left-0 top-0 bottom-0 w-8 md:w-12 z-10 pointer-events-none hidden md:block"
//       style={{
//         background: 'linear-gradient(to right, rgb(248 250 252) 0%, rgba(248, 250, 252, 0) 100%)'
//       }}
//     />

//     <div className="flex overflow-x-auto gap-4 pb-4 px-12 no-scrollbar">
//       {influencersData.map((influencer) => renderInfluencerCard(influencer, true))}
//     </div>

//     {/* Right gradient shadow */}
//     <div className="absolute right-0 top-0 bottom-0 w-8 md:w-12 z-10 pointer-events-none hidden md:block"
//       style={{
//         background: 'linear-gradient(to left, rgb(248 250 252) 0%, rgba(248, 250, 252, 0) 100%)'
//       }}
//     />
//   </div>
// ) : (
//   // Grid Layout
//   <div className="max-w-7xl mx-auto">
//     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-y-4 gap-x-3">
//       {influencersData.map((influencer) => renderInfluencerCard(influencer, false))}
//     </div>
//   </div>
// )}